import './App.css';
import NavAuth from './Components/NavAuth';
import { Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Register from './Components/Register';
import Login from './Components/Login';
import LoginPortal from './Components/LoginPortal';
import RegisterPortal from './Components/RegisterPortal';
import AdminLogin from './Components/AdminLogin';
import PrivateRoute from './Components/PrivateRoute';
import Errors from './Components/Errors';
import ListUser from './Components/ListUser';
import UpdateUser from './Components/UpdateUser';
import UpdateProfil from './Components/UpdateProfil';
import NProfil from './Components/NProfil';
import SalonBookingModule from './Components/SalonBookingModule';
import ServiceManagement from './Components/ServiceManagement';
import PackManagement from './Components/PackManagement';
import ActivityManagement from './Components/ActivityManagement';


// New Multi-Provider Marketplace Components
import ProviderRegister from './Components/ProviderRegister';
import ProviderLogin from './Components/ProviderLogin';
import ProviderDashboard from './Components/ProviderDashboard';
import AdminApprovals from './Components/AdminApprovals';
import Boutique from './Components/Boutique';
import QRCodeConfirmation from './Components/QRCodeConfirmation';

function App() {
  return (
    <div>
      <NavAuth/>
      <Errors/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/Register' element={<RegisterPortal/>}/>
        <Route path='/ClientRegister' element={<Register/>}/>
        <Route path='/Login' element={<LoginPortal/>}/>
        <Route path='/ClientLogin' element={<Login/>}/>
        <Route path='/AdminLogin' element={<AdminLogin/>}/>
        <Route path='/ProviderRegister' element={<ProviderRegister/>}/>
        <Route path='/ProviderLogin' element={<ProviderLogin/>}/>
        
        {/* Marketplace Routes */}
        <Route path='/Boutique/:providerId' element={<Boutique/>}/>
        <Route path='/QRCodeConfirmation.js' element={<QRCodeConfirmation/>}/>
        <Route path='/ProviderDashboard' element={<PrivateRoute><ProviderDashboard/></PrivateRoute>}/>
        <Route path='/AdminApprovals' element={<PrivateRoute><AdminApprovals/></PrivateRoute>}/>
        
        {/* Reservation / Booking Routes */}
        <Route path='/SalonBookingModule' element={<PrivateRoute><SalonBookingModule/></PrivateRoute>}/>
        <Route path='/ServiceManagement' element={<PrivateRoute><ServiceManagement/></PrivateRoute>}/>
        <Route path='/PackManagement' element={<PrivateRoute><PackManagement/></PrivateRoute>}/>
        <Route path='/ActivityManagement' element={<PrivateRoute><ActivityManagement/></PrivateRoute>}/>
        
        <Route path='/Profil' element={<PrivateRoute><NProfil/></PrivateRoute>}/>
        <Route path='/AllUser' element ={<ListUser/>}/>
        <Route path='/UpdateUser/:id' element ={<UpdateUser/>}/>
        <Route path='/UpdateProfil' element ={<UpdateProfil/>}/>
      </Routes>
    </div>
  );
}

export default App;
